import { createLayoutApp } from "../layout/createLayoutApp";
import HomeApp from "../home/HomeAppDesktop.vue";

const mountEl = document.getElementById("home-page-app");
if (mountEl && mountEl.getAttribute("data-vue3") === "true") {
  const raw = mountEl.getAttribute("data-view-model");
  const viewModel = raw ? JSON.parse(raw) : null;
  const app = createLayoutApp(HomeApp, { viewModel });
  app.mount(mountEl);
}
